
import React, {FC} from 'react';
import {BarColors} from 'templates/reports/colors';

import * as styles from './styles.module.scss';

type ColorBarProps = {
	breaks: number[]
	percentile: number
	reverse?: boolean
}

type StyleProps = {
	style: React.CSSProperties
}

const ColorBar: FC<ColorBarProps> = ({breaks, percentile, reverse}) => {
	const colors = [
		BarColors.green,
		BarColors.yellow,
		BarColors.red,
	];

	const color = (i: number): StyleProps => {
		const length = Math.round(
			(breaks[i+1] - breaks[i]) /
			(breaks[3] - breaks[0]) * 100
		);
		const color = !reverse ? colors[i] : colors[2-i];
		return {
			style: {
				backgroundColor: color,
				width: `${length}%`,
			}
		};
	};

	const marker = (v: number): StyleProps => {
		return {
			style: {
				left: `${v}%`,
			}
		};
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.bars}>
				<div {...color(0)} />
				<div {...color(1)} />
				<div {...color(2)} />
			</div>
			<div className={styles.track}>
				<div className={styles.marker}
					{...marker(percentile)}
				/>
			</div>
		</div>
	);
};

export default ColorBar;
